<script setup>
import Footer from "@/components/Footer.vue";
import CreateView from "@/views/CreateView.vue";
import { useEventsStore } from "@/stores/events.js";

const eventsStore = useEventsStore();

function createEvent(newEvent) {
    // For now, just log the new event
    const success = eventsStore.addNewEvent(newEvent);
    if (success) {
        alert("Event created successfully!");
    } else {
        alert("Failed to create event.");
    }
    

}

</script>

<template>
    <div class="rounded-none border-none bg-neutral-100">
        <CreateView
        @onCreateEvent="createEvent"
        ></CreateView>
        <Footer></Footer>
    </div>
</template>